<template>
  <!-- 新增出库 -->
  <div class="form">
    <div class="container">
      <!-- 上方表单 -->
      <el-form ref="basicForm" :model="formData" label-width="110px">
        <el-row>
          <el-col span="6">
            <el-form-item label="项目名称：" prop="projectId" required>
              <el-select
                style="width: 100%"
                v-model="formData.projectId"
                placeholder="请选择 项目名称"
                disabled
              >
                <el-option
                  v-for="(item, index) in projectList"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="6">
            <el-form-item
              label="出库单号："
              prop="outboundNo"
              :rules="[
                {
                  pattern: /^[a-zA-Z0-9]+$/,
                  message: '请输入正确的出库单号',
                  trigger: ['blur', 'change'],
                },
              ]"
            >
              <el-input
                placeholder="不填则自动编号"
                maxlength="50"
                show-word-limit
                clearable
                v-model="formData.outboundNo"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col span="6">
            <el-form-item label="出库类型：" prop="type" required>
              <el-select style="width: 100%" v-model="formData.type" placeholder="请选择 出库类型">
                <el-option
                  v-for="(item, index) in typeList"
                  :key="index"
                  :label="item.dictValue"
                  :value="item.dictKey"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="6">
            <el-form-item
              :label="formData.type == TYPE_MAP.TRANSFER ? '调出仓库：' : '出库仓库：'"
              prop="warehouseId"
              required
            >
              <el-select
                style="width: 100%"
                v-model="formData.warehouseId"
                placeholder="请选择 仓库"
              >
                <el-option
                  v-for="(item, index) in warehouseList"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <template v-if="formData.type == TYPE_MAP.PURCHASE">
            <el-col span="6">
              <el-form-item
                label="订单号："
                prop="linkNo"
                :rules="[
                  {
                    pattern: /^[a-zA-Z0-9]+$/,
                    message: '请输入正确的订单号',
                    trigger: ['blur', 'change'],
                  },
                ]"
              >
                <el-input
                  placeholder="请输入 订单号"
                  v-model="formData.linkNo"
                  :maxlength="50"
                  :show-word-limit="true"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
          </template>
          <template v-if="formData.type == TYPE_MAP.USE">
            <el-col span="6">
              <el-form-item
                label="领用申请单："
                prop="linkNo"
                :rules="[{ required: true, message: '请选择领用申请单' }]"
              >
                <!-- 点击事件直接放在el-input不会触发，所以外层报一个div来响应事件 -->
                <div @click="openUseOrderListDialog">
                  <el-input
                    placeholder="请选择 单号"
                    v-model="formData.linkNo"
                    :readonly="true"
                  ></el-input>
                </div>
              </el-form-item>
            </el-col>
            <el-col span="6">
              <el-form-item label="领用部门：">
                <el-select style="width: 100%" v-model="useOrderObj.deptName" disabled> </el-select>
              </el-form-item>
            </el-col>
            <el-col span="6">
              <el-form-item label="领用人：">
                <el-select style="width: 100%" v-model="useOrderObj.userName" disabled> </el-select>
              </el-form-item>
            </el-col>
          </template>
          <template v-if="formData.type == TYPE_MAP.TRANSFER">
            <el-col span="6">
              <el-form-item
                label="调拨单号："
                prop="linkNo"
                :rules="[{ required: true, message: '请选择调拨单' }]"
              >
                <!-- 点击事件直接放在el-input不会触发，所以外层报一个div来响应事件 -->
                <div @click="openTransferOrderListDialog">
                  <el-input
                    placeholder="请选择 单号"
                    v-model="formData.linkNo"
                    :readonly="true"
                  ></el-input>
                </div>
              </el-form-item>
            </el-col>
            <el-col span="6">
              <el-form-item label="调入仓库：">
                <el-select
                  style="width: 100%"
                  v-model="transferOrderObj.destWarehouseId"
                  placeholder="请选择 仓库"
                  disabled
                >
                  <el-option
                    v-for="(item, index) in warehouseList"
                    :key="index"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </template>

          <el-col span="6">
            <el-form-item label="经办人：" prop="handleUser">
              <el-input
                placeholder="请输入 经办人"
                :maxlength="30"
                :show-word-limit="true"
                clearable
                v-model="formData.handleUser"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col span="6">
            <el-form-item
              label="联系电话："
              prop="tel"
              :rules="[
                {
                  pattern: /^((0\d{2,3}-\d{7,8})|(1[3456789]\d{9}))$/,
                  message: '请输入正确的电话',
                  trigger: ['blur', 'change'],
                },
              ]"
            >
              <el-input placeholder="请输入 联系电话" clearable v-model="formData.tel"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="备注说明：" prop="remark">
          <el-input
            type="textarea"
            :rows="3"
            :maxlength="200"
            :show-word-limit="true"
            v-model="formData.remark"
            placeholder="请输入 备注"
            clearable
          />
        </el-form-item>
      </el-form>
      <hr />
      <!-- 物料区域 -->
      <!-- 调拨出库 -->
      <template v-if="formData.type == TYPE_MAP.TRANSFER">
        <TransferGoodsList
          :projectId="formData.projectId"
          :warehouseId="formData.warehouseId"
          :orderId="transferOrderObj.id || ''"
          @update="updateGoodsInfo"
        ></TransferGoodsList>
      </template>
      <!-- 领用出库 -->
      <template v-else-if="formData.type == TYPE_MAP.USE">
        <UseGoodsList
          :projectId="formData.projectId"
          :warehouseId="formData.warehouseId"
          :orderId="useOrderObj.id || ''"
          @update="updateGoodsInfo"
        ></UseGoodsList>
      </template>
      <!-- 采购退库 -->
      <template v-else>
        <GoodsManagement
          :projectId="formData.projectId"
          :warehouseId="formData.warehouseId"
          @update="updateGoodsInfo"
        ></GoodsManagement>
      </template>
      <hr />
      <!-- 附件区域 -->
      <UploadTable
        :fileMaxNum="5"
        :fileMaxSize="12 * 1024 * 1024"
        fileType=".png,.jpg,.jpeg,.xlx,.xlsx,.doc,.docx,.ppt,.pptx"
        tips="（最多上传5个，单个文件限制在12Mb内，支持png、jpg、jpeg、xlx、xlsx、doc、docx、ppt、pptx类型文件）"
        @update="updateAttachList"
      ></UploadTable>
    </div>
    <!-- 按钮占位区域 -->
    <div class="placeholder"></div>
    <!-- 底部操作按钮 -->
    <div class="btn">
      <el-button type="primary" size="small" @click="doSave">提交</el-button>
      <el-button size="small" @click="doClose">取消</el-button>
    </div>
    <!-- 调拨单列表的弹框 -->
    <el-dialog
      title="调拨单"
      width="80%"
      :visible.sync="isTransferOrderDialogShow"
      :append-to-body="true"
      :modal-append-to-body="true"
      :close-on-click-modal="false"
      :destroy-on-close="true"
    >
      <TransferOrderList
        v-if="isTransferOrderDialogShow"
        :projectId="formData.projectId"
        :warehouseId="formData.warehouseId"
        @update="updateTransferOrderObj"
        @close="closeTransferOrderListDialog"
      ></TransferOrderList>
    </el-dialog>
    <!-- 领用申请单列表的弹框 -->
    <el-dialog
      title="领用申请单"
      width="80%"
      :visible.sync="isUseOrderDialogShow"
      :append-to-body="true"
      :modal-append-to-body="true"
      :close-on-click-modal="false"
      :destroy-on-close="true"
    >
      <UseOrderList
        v-if="isUseOrderDialogShow"
        :projectId="formData.projectId"
        :warehouseId="formData.warehouseId"
        @update="updateUseOrderObj"
        @close="closeUseOrderListDialog"
      ></UseOrderList>
    </el-dialog>
  </div>
</template>

<script>
import GoodsManagement from './goods-management';
import TransferOrderList from './transfer-order-list';
import TransferGoodsList from './transfer-goods-list';
import UseOrderList from './use-order-list';
import UseGoodsList from './use-goods-list';
import UploadTable from '../components/upload-table';
import { getProjectListApi, getDictApi, getWarehouseListApi } from '@/api/warehouse/index';
import { addApi } from '@/api/warehouse/out';
import mixin from '../mixin';

export default {
  name: 'WarehouseOutForm',
  mixins: [mixin],
  components: {
    GoodsManagement,
    TransferOrderList,
    TransferGoodsList,
    UseOrderList,
    UseGoodsList,
    UploadTable,
  },
  props: ['projectId'],
  data() {
    return {
      // 出库类型映射后端的字典配置
      TYPE_MAP: {
        USE: 1, // 领用出库
        TRANSFER: 2, // 调拨出库
        PURCHASE: 4, // 采购退货
      },
      formData: {
        projectId: '',
        warehouseId: '',
        type: '', // 出库类型
        linkNo: '', // 关联订单号
      },
      projectList: [],
      warehouseList: [],
      goodsData: {},
      attachList: [],
      // 领用申请单列表的弹框是否显示着
      isUseOrderDialogShow: false,
      // 选中的领用申请单对象
      useOrderObj: {},
      // 调拨单列表的弹框是否显示着
      isTransferOrderDialogShow: false,
      // 选中的调拨单对象
      transferOrderObj: {},
    };
  },
  created() {
    getProjectListApi().then(({ data }) => {
      this.projectList = data || [];
      this.formData.projectId = this.projectId;
    });
    getDictApi({
      code: 'warehouse_outbound_type',
    }).then(({ data }) => {
      // 不要【盘点出库】
      let index = data.findIndex((item) => {
        return item.dictValue == '盘点出库';
      });
      if (index != -1) {
        data.splice(index, 1);
      }
      // 要求临时屏蔽掉【采购退货】
      index = data.findIndex((item) => {
        return item.dictValue == '采购退货';
      });
      if (index != -1) {
        data.splice(index, 1);
      }
      this.typeList = data;
      this.formData.type = this.typeList[0].dictKey; // 默认选择第一项类型
    });
  },
  watch: {
    'formData.projectId'(val) {
      if (val) {
        this.formData.warehouseId = '';
        // 更新仓库列表
        getWarehouseListApi({
          projectId: this.formData.projectId,
        }).then(({ data }) => {
          this.warehouseList = data;
          if (this.warehouseList.length > 0) {
            let firstWarehouse = this.warehouseList.find((ele) => {
              return ele.status == 1;
            });
            this.formData.warehouseId = firstWarehouse ? firstWarehouse.id : '';
          }
        });
        this.resetSomeData();
      }
    },
    'formData.warehouseId'(val) {
      this.resetSomeData();
    },
    'formData.type'(val) {
      this.resetSomeData();
    },
  },
  methods: {
    /* 重置部分数据 */
    resetSomeData() {
      // 切换表单里的前置选项时清空其它信息
      this.formData.linkNo = '';
      this.transferOrderObj = {};
      this.useOrderObj = {};
      this.$refs.basicForm.clearValidate();
    },
    /* 显示调拨单列表的弹框 */
    openTransferOrderListDialog() {
      this.isTransferOrderDialogShow = true;
    },
    /* 调拨单列表回传的数据 */
    updateTransferOrderObj(item) {
      this.transferOrderObj = item;
      this.formData.linkNo = this.transferOrderObj.allotNo;
    },
    /* 关闭调拨单列表的弹框 */
    closeTransferOrderListDialog() {
      this.isTransferOrderDialogShow = false;
    },
    /* 显示领用申请单列表的弹框 */
    openUseOrderListDialog() {
      this.isUseOrderDialogShow = true;
    },
    /* 领用申请单列表回传的数据 */
    updateUseOrderObj(item) {
      this.useOrderObj = item;
      this.formData.linkNo = this.useOrderObj.requisitionNo;
    },
    /* 关闭领用申请单列表的弹框 */
    closeUseOrderListDialog() {
      this.isUseOrderDialogShow = false;
    },
    /* 物料列表子组件同步的数据 */
    updateGoodsInfo(data) {
      this.goodsData = data;
    },
    /* 附件子组件同步的数据 */
    updateAttachList(data) {
      this.attachList = data;
    },
    /* 新增出库单 */
    doSave() {
      this.$refs.basicForm.validate((valid) => {
        if (valid) {
          let list = this.goodsData.list || [];
          if (list.length == 0) {
            this.$message.error('请先添加物料明细！');
            return;
          }
          let index = list.findIndex((item) => {
            return !item.outboundNum || item.outboundNum <= 0;
          });
          if (index != -1) {
            this.$message.error('【本次出库数量】须为正整数');
            return;
          }
          index = list.findIndex((item) => {
            return item.outboundNum > item.stockNum;
          });
          if (index != -1) {
            this.$message.error('出库数量不能大于存库数量');
            return;
          }
          const loading = this.$loading({
            lock: true,
            text: '提交中...',
            spinner: 'el-icon-loading',
          });
          list = list.map((item) => {
            // 后端要求把list里的id都置空
            item.id = '';
            // 补全未计算到(没有渲染的页码就不会计算)的数据项的换算数量和本次出库金额
            if (!item.conversionNum) {
              item.conversionNum = this.convertGoodsUnit(item, 'outboundNum');
              item.inboundPrice = item.inboundNum * item.price || '';
            }
            return item;
          });
          let params = {
            projectId: this.formData.projectId, // 项目id
            warehouseId: this.formData.warehouseId || '', // 仓库id
            type: this.formData.type, // 出库类型
            outboundNo: this.formData.outboundNo, // 出库单号
            linkNo: this.formData.linkNo, // 关联单号
            remark: this.formData.remark, // 注备
            handleUser: this.formData.handleUser, // 经办人
            tel: this.formData.tel, // 电话
            outboundAmount: this.goodsData.sumMoney || 0, // 出库总金额
            outboundNum: this.goodsData.sumNum || 0, // 出库总数量
            consumableList: list, // 出库货品集合
            outboundFileUrlList: this.attachList, // 附件集合
          };
          if (this.formData.type == this.TYPE_MAP.USE) {
            params.requisitionDept = this.useOrderObj.requisitionDept;
            params.requisitionUser = this.useOrderObj.requisitionUser;
          }
          addApi(params)
            .then(() => {
              loading.close();
              this.$message.success('操作成功!');
              this.$emit('update');
            })
            .catch(() => {
              loading.close();
            });
        }
      });
    },
    doClose() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../dialog-form.scss';

hr {
  margin: 30px 0;
}
</style>
